export default {
    blogs   : {
        list            : [],
        details         : []
    }
}